import { render, staticRenderFns } from "./r-avatar.vue?vue&type=template&id=6f394cae&shadow"
import script from "./r-avatar.vue?vue&type=script&lang=js&shadow"
export * from "./r-avatar.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./r-avatar.vue?vue&type=style&index=0&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports